import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "../features/api/apiSlice";
import projectsSliceReducer from "../features/projects/projectsSlice";
import teamsSliceReducer from "../features/teams/teamsSlice";
import tasksSliceReducer from "../features/tasks/tasksSlice";

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    projects: projectsSliceReducer,
    teams: teamsSliceReducer,
    tasks: tasksSliceReducer,
  },
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddlewares) =>
    getDefaultMiddlewares({
      serializableCheck: false,
    }).concat(apiSlice.middleware),
});
